module.exports = __webpack_public_path__ + "static/media/camera.6799705e.svg";